import { PlayIcon } from '../icons/icons';
import React, { SyntheticEvent } from 'react';
import './oe-next-prev-stepper.scss';
import { FormattedMessage } from 'react-intl';
import { SelectionAction } from '../../_events/_manage-event/_control/control.viewmodel';
import DefaultButton from '../default-button/default-button';
import { isDatesEquals } from '../../../infrastructure/utils/common.utils';

interface IProps {
    datesArray: Date[];
    selectedHour: Date;
    changeHour: (action: SelectionAction) => void;
    eventTimeZone?: string;
    daysArray?: Date[];
    selectedDay?: Date;
    changeDay?: (action: SelectionAction) => void;
    isDayFilter?: boolean;
    withNowButton?: boolean;
    isNowDisabled?: boolean;
    isNextDisabled?: boolean;
}

const NextPrevStepper = (props: IProps) => {
    const {datesArray, selectedHour, changeHour, isNowDisabled = false, isNextDisabled = false, isDayFilter = false,
        daysArray, selectedDay, changeDay, withNowButton = false} = props;

    const array = isDayFilter ? daysArray : datesArray;
    const currentValue = isDayFilter ? selectedDay : selectedHour;
    const stepHandler = isDayFilter ? changeDay : changeHour;

    const currentTimeInFilterHours = array.find(hour => {
        return isDatesEquals(hour, currentValue);
    });
    const currentHourIndex = array.indexOf(currentTimeInFilterHours);
    const isHoursArrayStart = currentHourIndex === 0;
    const isHoursArrayEnd = (currentHourIndex + 1) === array?.length;

    const handleClick = (
        e: SyntheticEvent,
        callback: IProps['changeHour' | 'changeDay'],
        args: SelectionAction
    ) => callback(args);

    return (
        <div className='hour-navigation' onClick={e => e.stopPropagation()}>
            <div className='hour-navigation__container'>
                <DefaultButton
                    className='hour-navigation-button hour-navigation-button__prev'
                    onClick={e => handleClick(e, stepHandler, SelectionAction.Previous)}
                    modifier='link'
                    disabled={isHoursArrayStart}
                    text={<FormattedMessage
                        id='oe.common.previous'
                        description='Button text'
                        defaultMessage='Previous'
                    />}
                    icon={PlayIcon}
                />
                {withNowButton && <DefaultButton
                    className='hour-navigation-button hour-navigation-button__now'
                    onClick={e => handleClick(e, changeHour, SelectionAction.Now)}
                    modifier='link'
                    disabled={isNowDisabled}
                    text={<FormattedMessage
                        id='oe.common.now'
                        description='Button text'
                        defaultMessage='Now'
                    />}
                />}
                <DefaultButton
                    className='hour-navigation-button hour-navigation-button__next'
                    onClick={e => handleClick(e, stepHandler, SelectionAction.Next)}
                    modifier='link'
                    disabled={isHoursArrayEnd || isNextDisabled}
                    text={<FormattedMessage
                        id='oe.common.next'
                        description='Button text'
                        defaultMessage='Next'
                    />}
                    icon={PlayIcon}
                />
            </div>
        </div>
    );
};

export default NextPrevStepper;